module.exports = __webpack_public_path__ + "static/media/tab-invoices-icon-active.3830302f.png";